"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["className", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DURATION = "1.4s";
var rotate = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(270deg);}"]);
var dash = (0, _styledComponents.keyframes)(["0%{stroke-dashoffset:187;transform:rotate(0deg);}50%{stroke-dashoffset:46.75;transform:rotate(135deg);}100%{stroke-dashoffset:187;transform:rotate(450deg);}}"]);

var Circle = function Circle(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 48 : _ref$size,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    className: className,
    width: size,
    height: size
  }, props), /*#__PURE__*/_react["default"].createElement("svg", {
    width: size + "px",
    height: size + "px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  })));
};

Circle.propTypes = (0, _extends2["default"])({}, _Flex["default"].propTypes, {
  className: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string.isRequired,
  justifyContent: _propTypes["default"].string,
  alignItems: _propTypes["default"].string
});
Circle.defaultProps = {
  justifyContent: "center",
  alignItems: "center"
};
var Spinner = (0, _styledComponents["default"])(Circle).withConfig({
  displayName: "Spinner",
  componentId: "sc-3l206z-0"
})(["svg{animation:", " ", " linear infinite;}svg > circle{stroke:", ";stroke-dasharray:187;stroke-dashoffset:0;transform-origin:center;animation:", " ", " ease-in-out infinite;}"], rotate, DURATION, function (props) {
  return (0, _styledSystem.color)(props).color;
}, dash, DURATION);
var _default = Spinner;
exports["default"] = _default;